import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PageAnalyticsService {
	constructor() {
		const router = inject(Router);
		const document = inject(DOCUMENT);
		const analyticsWindow = document.defaultView as
			| (Window & {
					gtag?: (
						command: string,
						event: string | Record<string, string>,
						parameters?: Record<string, string>
					) => void;
			  })
			| null;
		if (!analyticsWindow) return;

		let previousLocation = '';
		if (document.referrer) {
			try {
				const referrer = new URL(document.referrer);
				previousLocation =
					referrer.origin +
					referrer.pathname
						.split('/')
						.map((segment) => (segment.startsWith('U2FsdGVk') || segment.length > 128 ? ':data' : segment))
						.join('/');
			} catch {
				previousLocation = '';
			}
		}

		router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				takeUntilDestroyed(inject(DestroyRef))
			)
			.subscribe(() => {
				const paths: string[] = [];
				let route = router.routerState.snapshot.root;
				while (route) {
					if (route.routeConfig?.path) paths.push(route.routeConfig.path);
					route = route.children.find((child) => child.outlet === PRIMARY_OUTLET);
				}
				const pageLocation = analyticsWindow.location.origin + '/' + paths.join('/');
				const parameters = {
					page_location: pageLocation,
					page_referrer: previousLocation,
					page_title: document.title
				};
				analyticsWindow.gtag?.('set', parameters);
				analyticsWindow.gtag?.('event', 'page_view', parameters);
				previousLocation = pageLocation;
			});
	}
}
